import Subscriptions from '../components/Subscriptions';
import ClinicalCenter from '../components/ClinicalCenter';
import Subscription from '../components/Subscription';
import TaskTypes from '../components/TaskTypes';
import Profile from '../components/Profile';
import SkillDomain from '../components/SkillDomain';
import ProfileLayout
  from '../components/ProfileLayout';


export default [
  {
    path: '/profile',
    component: ProfileLayout,
    children: [
      {
        path: 'edit',
        name: 'profile',
        component: Profile,
      },
      {
        path: 'subscriptions',
        name: 'subscriptions',
        props: true,
        component: Subscriptions,
      },
      {
        path: 'subscriptions/:id',
        name: 'subscription',
        props: true,
        component: Subscription,
      },
      {
        path: 'clinic-center',
        name: 'clinic-center',
        props: true,
        component: ClinicalCenter,
      },
      {
        path: 'task-types',
        name: 'task-types',
        props: true,
        component: TaskTypes,
      },
      {
        path: 'skill-domain',
        name: 'skill-domain',
        props: true,
        component: SkillDomain,
      },
    ]
  },
];



// WEBPACK FOOTER //
// ./src/modules/profile/routes/index.js